<template>
  <div>
    <!-- table -->
    <el-table 
      v-loading="listLoading"
      :data="noteList" style="width: 100%;" 
      :cell-style="{padding: '0', height: '40px'}"
      @sort-change="tableSortChange"
     >
      <el-table-column align="center" label="警示日期">
        <template slot-scope="scope">
          {{ scope.row.openedOn ? $moment(scope.row.openedOn).format('YYYY-MM-DD') : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" prop="type.note" label="異常值"/>
      <el-table-column align="center" prop="waterNum" label="水號"/>
      <el-table-column align="center" prop="meterNum" label="表號"/>
      <el-table-column align="center" prop="alias" label="用戶別名"/>
      <el-table-column align="center" prop="address" label="地址"/>
      <el-table-column align="center" label="電子郵件1">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[0] ? scope.row.notifyMails[0] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件2">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[1] ? scope.row.notifyMails[1] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件3">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[2] ? scope.row.notifyMails[2] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件4">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[3] ? scope.row.notifyMails[3] : '' }}
        </template>
      </el-table-column>
      <el-table-column align="center" label="電子郵件5">
        <template slot-scope="scope">
          {{ scope.row.notifyMails && scope.row.notifyMails[4] ? scope.row.notifyMails[4] : '' }}
        </template>
      </el-table-column> 
      <el-table-column align="center" label="聯絡電話">
        <template slot-scope="scope">
          {{ scope.row.notifyPhones && Array.isArray(scope.row.notifyPhones) && scope.row.notifyPhones.length > 0 ? scope.row.notifyPhones.join(", ") : '' }}
        </template>
      </el-table-column>
    </el-table>

    <!--分頁組件-->
    <pagination v-show="total>0" :total="total" :current.sync="paginationSelectedPage" :size.sync="listQuery.size" @pagination="getAlarmProfile"/>

  </div>
</template>

<script>
import Pagination from '@/components/Pagination'
import { mixins } from '@/views/common/mixins.js'
import _ from 'lodash'

export default {
  // 異常案件類型列表
  name: 'AlarmList',
  components: {
    Pagination
  },
  mixins: [mixins], 
  props: {
    dateRange:{
      require: true,
      default: undefined,
      type: Array
    }
  },
  data() {
    return {
      total: 0,
      noteList:[],
      listLoading: false,
      queryAlarmHistory: {
        start: this.dateRange[0],
        end: this.dateRange[1]
      },
      listQuery: {
        page: 0, // jpa pageIndex起始從0開始，但Pagination從1開始，透過watch paginationSelectedPage同步
        size: 5
      },
      paginationSelectedPage: 1, // 需配合Pagination元件與listQuery使用
    };
  },
  computed: {
    currentProfile() {
      return JSON.parse(localStorage.getItem('currentProfile'))
    }
  },
  watch: {
    paginationSelectedPage: {
      handler: function(newValue) {
        this.listQuery.page = newValue - 1
      }
    },
    dateRange(val) {
      this.queryAlarmHistory.start = val[0];
      this.queryAlarmHistory.end = val[1];
    }
  },
  async created(){
    if (this.currentProfile) {
      this.getAlarmProfile() // 取得異常案件類型列表
    }
  },
  methods: {
    getAlarmProfile() {
      this.listLoading = true
      const params = {
        ...this.queryAlarmHistory,
        page: this.listQuery.page,
        size: this.listQuery.size
      };
      this.axios.get('/api/report/profile/' + this.currentProfile.waterId + '/alarmPage', {params: params}).then(res => {
        this.total = res.data.totalElements
        if(_.isArray(res.data.content))
        {
          this.noteList = res.data.content
        } else {
          this.noteList = []
        }
        this.listLoading = false
      })
    }
  }
}
</script>